/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExceptionItem
 */
export interface ExceptionItem {
    /**
     * 
     * @type {string}
     * @memberof ExceptionItem
     */
    initiativeId?: string;
    /**
     * 
     * @type {string}
     * @memberof ExceptionItem
     */
    initiativeName?: string;
    /**
     * 
     * @type {string}
     * @memberof ExceptionItem
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof ExceptionItem
     */
    severity?: string;
    /**
     * 
     * @type {string}
     * @memberof ExceptionItem
     */
    message?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof ExceptionItem
     */
    details?: { [key: string]: string; };
}

/**
 * Check if a given object implements the ExceptionItem interface.
 */
export function instanceOfExceptionItem(value: object): value is ExceptionItem {
    return true;
}

export function ExceptionItemFromJSON(json: any): ExceptionItem {
    return ExceptionItemFromJSONTyped(json, false);
}

export function ExceptionItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExceptionItem {
    if (json == null) {
        return json;
    }
    return {
        
        'initiativeId': json['initiativeId'] == null ? undefined : json['initiativeId'],
        'initiativeName': json['initiativeName'] == null ? undefined : json['initiativeName'],
        'type': json['type'] == null ? undefined : json['type'],
        'severity': json['severity'] == null ? undefined : json['severity'],
        'message': json['message'] == null ? undefined : json['message'],
        'details': json['details'] == null ? undefined : json['details'],
    };
}

export function ExceptionItemToJSON(json: any): ExceptionItem {
    return ExceptionItemToJSONTyped(json, false);
}

export function ExceptionItemToJSONTyped(value?: ExceptionItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'initiativeId': value['initiativeId'],
        'initiativeName': value['initiativeName'],
        'type': value['type'],
        'severity': value['severity'],
        'message': value['message'],
        'details': value['details'],
    };
}

